import { createContext } from 'react';

// The active date range, published by DateRangeFilter and read by ChartCard so
// a shared chart or table records which period it covers.
//
// Deliberately a ref rather than state: the range is only needed at the moment
// the share button is pressed, so writing it costs no re-render of the page.
// A page with no filter leaves it null and the exports omit the line.
export const DateRangeContext = createContext({ current: null });
